import { Extension } from '@tiptap/core';
import type { Slice } from '@tiptap/pm/model';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { toast } from 'sonner';

const ZYTERM_PASTE_TOAST =
    'WARNING: You attempted to paste a `zyTerm`. `zyTerm` is a deprecated zyTag and is no longer supported. Use `zyDefn` instead.';

function sliceContainsZyTerm(slice: Slice): boolean {
    let found = false;
    slice.content.descendants(node => {
        if (node.type.name === 'zyTerm') {
            found = true;
            return false;
        }
        return true;
    });
    return found;
}

export const ZyTermPasteBlock = Extension.create({
    name: 'zyTermPasteBlock',

    priority: 10000,

    addProseMirrorPlugins() {
        return [
            new Plugin({
                key: new PluginKey('zyTermPasteBlock'),
                props: {
                    handlePaste: (_view, _event, slice) => {
                        if (sliceContainsZyTerm(slice)) {
                            toast.warning(ZYTERM_PASTE_TOAST);
                            return true;
                        }
                        return false;
                    },
                },
            }),
        ];
    },
});
